import axiosIns from '../../../../xaxios';
import { obtenerUrlAPICalificaciones } from '../utils/funciones';

const recurso = 'accesos';

export default {

  async verificarAccesoDna() {
    return await axiosIns.get(obtenerUrlAPICalificaciones(`${recurso}/acceso-dna`));
  },

};
